import Swiper from "swiper/core";
import { Navigation } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';

new Swiper(".product-card__slider", {
    modules: [Navigation],
    navigation: {
        nextEl: ".product-card__slider__nav--next",
        prevEl: ".product-card__slider__nav--prev",
    },
});
